'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.956-199.608 57.238zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM832 512h-128v128h-64v-128h-128v-64h128v-128h64v128h128z' })
    ));
};